function initializeMarquee(container) {
  const marqueeText = container.querySelector(".marquee-text");

  if (!marqueeText) return;

  // Prevent duplicate clones when Shopify reloads the section
  if (container.dataset.marqueeInitialized === "true") return;
  container.dataset.marqueeInitialized = "true";

  let textWidth = marqueeText.getBoundingClientRect().width;
  let textHeight = marqueeText.offsetHeight;
  let position = 0;
  let lastTime = null;

  const speed = 45; // pixels per second. Lower = slower, higher = faster.

  container.style.height = textHeight + "px";
  container.style.overflow = "hidden";

  marqueeText.style.position = "absolute";
  marqueeText.style.left = "0px";
  marqueeText.style.willChange = "transform";
  marqueeText.style.transform = "translate3d(0, 0, 0)";

  // Clone enough copies to keep the banner filled
  for (let i = 1; i <= 20; i++) {
    const marqueeTextClone = marqueeText.cloneNode(true);
    marqueeTextClone.style.position = "absolute";
    marqueeTextClone.style.left = textWidth * i + "px";
    marqueeTextClone.style.willChange = "transform";
    marqueeTextClone.style.transform = "translate3d(0, 0, 0)";
    container.appendChild(marqueeTextClone);
  }

  function updatePositions() {
    const items = container.querySelectorAll(".marquee-text");

    items.forEach(function(item) {
      item.style.transform = "translate3d(" + position + "px, 0, 0)";
    });
  }

  function animateMarquee(timestamp) {
    if (!lastTime) lastTime = timestamp;

    const delta = timestamp - lastTime;
    lastTime = timestamp;

    position -= (speed * delta) / 1000;

    if (position <= -textWidth) {
      position += textWidth;
    }

    updatePositions();
    requestAnimationFrame(animateMarquee);
  }

  requestAnimationFrame(animateMarquee);

  window.addEventListener("resize", function() {
    textWidth = marqueeText.getBoundingClientRect().width;
    textHeight = marqueeText.offsetHeight;
    position = 0;
    lastTime = null;

    container.style.height = textHeight + "px";

    const items = container.querySelectorAll(".marquee-text");

    items.forEach(function(item, index) {
      item.style.left = textWidth * index + "px";
      item.style.transform = "translate3d(0, 0, 0)";
    });
  });
}

window.addEventListener("load", function() {
  const marqueeContainers = document.querySelectorAll(".marquee-container");
  marqueeContainers.forEach(initializeMarquee);
});

document.addEventListener("shopify:section:load", function(event) {
  const section = document.querySelector(
    "#shopify-section-" + event.detail.sectionId
  );

  if (!section) return;

  const marqueeContainer = section.querySelector(".marquee-container");

  if (marqueeContainer) {
    marqueeContainer.dataset.marqueeInitialized = "false";
    initializeMarquee(marqueeContainer);
  }
});